var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer"},[_c('Menu',{attrs:{"items":_vm.links}}),_c('span',{staticClass:"note"},[_vm._v("\n    Prototype Stadium - Copyright "),_c('span',[_vm._v(_vm._s(_vm.currentYear))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }